import React from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

export default function FilesTab(props) {
    // props
    const { } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* btns */}
                    <div className="btns d-flex flex-wrap align-items-center mb-3">
                        <button className="st-btn st-btn-white-gray-outlined st-btn-sm d-flex align-items-center text-capitalize">
                            <span className="round-feather-icon-outlined hoverable d-inline-flex align-items-center justify-content-center me-2">
                                <FeatherIcon
                                    icon="plus"
                                    size="10"
                                    className="icon cursor-pointer" />
                            </span>
                            <span>Upload Files</span>
                        </button>
                        <p className="ms-auto st-fs-13 st-text-color2">Drag and drop items to sort</p>

                        <div className="w-100 mt-2">
                            <p className="ms-auto st-fs-13 st-text-color2">These files will be available to the customers once the order recieves status pad.</p>
                        </div>
                    </div>

                    <div className="files-table page-border-box">
                        <div className="ft-inner pbb-inner table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="50" className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </th>
                                        <th>Name</th>
                                        <th width="320">Description</th>
                                        <th width="75">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color2 ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="st-form form-sm mb-0">
                                                <input type="text" className="form-control" placeholder="Description" />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color2 ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="st-form form-sm mb-0">
                                                <input type="text" className="form-control" placeholder="Description" />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color2 ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="st-form form-sm mb-0">
                                                <input type="text" className="form-control" placeholder="Description" />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color2 ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="st-form form-sm mb-0">
                                                <input type="text" className="form-control" placeholder="Description" />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color2 ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="st-form form-sm mb-0">
                                                <input type="text" className="form-control" placeholder="Description" />
                                            </div>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
